
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/docs/antara/tutorials/advanced-series-2",
      function () {
        return require("private-next-pages/en/docs/antara/tutorials/advanced-series-2/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/docs/antara/tutorials/advanced-series-2"])
      });
    }
  